import React from 'react';
import { PlayIcon, Image as ImageIcon, CheckCircleIcon, ChevronRightIcon } from 'lucide-react';
const FEATURED_CASES = [{
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/cLX9rprdMdnvDnaxP2LP2U/testi-fran-video-reel_CLEEoFyL.mp4',
  label: 'Caso Fran'
}, {
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/8ZnUyxtNTz1R79zWqCyuHP/testi-sandra_6j1tJRTh.mp4',
  label: 'Caso Sandra'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/mpEwaqJihZtDhBxQ4uYL3K/DEJA_EL_TRABAJO.png',
  label: 'Caso Flor'
}];
interface FeaturedTestimonialsProps {
  onOpenModal: () => void;
}
export function FeaturedTestimonials({
  onOpenModal
}: FeaturedTestimonialsProps) {
  return <div className="w-full bg-gradient-to-b from-brand-bg to-brand-card/20 py-16 border-b border-gray-800" data-id="element-7">
      <div className="max-w-6xl mx-auto px-4" data-id="element-8">
        {/* Header Section */}
        <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-9">
          <h2 className="text-2xl md:text-4xl font-black mb-4 text-white leading-tight" data-id="element-10">
            No querían ser empleados toda la vida.
          </h2>
          <p className="text-gray-300 text-lg md:text-xl leading-relaxed" data-id="element-11">
            Empezaron aplicando el Sistema AIC mientras trabajaban. Hoy ya no
            dependen exclusivamente de un sueldo.
          </p>
        </div>

        {/* Video/Image Grid */}
        <div className="flex overflow-x-auto md:grid md:grid-cols-3 gap-6 pb-8 md:pb-0 snap-x snap-mandatory scrollbar-hide mb-16" data-id="element-12">
          {FEATURED_CASES.map((item, index) => <div key={index} className="min-w-[85vw] md:min-w-0 snap-center flex flex-col" data-id="element-13">
              <div className="relative rounded-2xl overflow-hidden border border-gray-800 shadow-2xl bg-black aspect-[9/16] group hover:border-brand-cyan/30 transition-colors duration-300" data-id="element-14">
                {item.type === 'video' ? <video src={item.src} controls className="w-full h-full object-cover" playsInline data-id="element-15">
                    Tu navegador no soporta videos.
                  </video> : <img src={item.src} alt={item.label} className="w-full h-full object-cover" data-id="element-16" />}

                {/* Label Badge */}
                <div className="absolute top-4 left-4 bg-black/60 backdrop-blur-md px-3 py-1 rounded-full border border-white/10 pointer-events-none z-10" data-id="element-17">
                  <span className="text-white text-xs font-bold tracking-wide uppercase flex items-center gap-2" data-id="element-18">
                    {item.type === 'video' ? <PlayIcon className="w-3 h-3 text-brand-gold fill-current" data-id="element-19" /> : <ImageIcon className="w-3 h-3 text-brand-cyan" data-id="element-20" />}
                    {item.label}
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Mobile Scroll Indicator Hint */}
        <div className="md:hidden flex flex-col items-center gap-2 -mt-12 mb-12" data-id="element-21">
          <div className="flex items-center gap-1.5 text-gray-400 text-xs font-medium animate-pulse" data-id="element-22">
            <span data-id="element-23">Deslizá para ver más</span>
            <span data-id="element-24">→</span>
          </div>
          <div className="flex gap-2" data-id="element-25">
            {FEATURED_CASES.map((_, i) => <div key={i} className="w-2 h-2 rounded-full bg-gray-700" data-id="element-26"></div>)}
          </div>
        </div>

        {/* New Content Section: Bullets & CTA */}
        <div className="max-w-3xl mx-auto bg-brand-card/30 border border-gray-800 rounded-2xl p-8 md:p-10" data-id="element-27">
          <div className="grid gap-4 mb-8" data-id="element-28">
            {['Empezaron con cero conocimientos ni experiencia.', 'Aplicaron el Sistema AIC y lanzaron su primera tienda en 48hs.', 'Validaron ventas mientras todavía estaban empleados.', 'Construyeron ingresos que les dieron opciones.'].map((text, i) => <div key={i} className="flex items-start gap-3" data-id="element-29">
                <div className="mt-1 min-w-[20px]" data-id="element-30">
                  <CheckCircleIcon className="w-5 h-5 text-brand-gold" data-id="element-31" />
                </div>
                <p className="text-gray-200 font-medium text-lg" data-id="element-32">{text}</p>
              </div>)}
          </div>

          <div className="text-center border-t border-gray-700/50 pt-8" data-id="element-33">
            <p className="text-xl md:text-2xl font-bold text-white mb-8 italic" data-id="element-34">
              "La libertad no empieza cuando renunciás. Empieza cuando decidís
              construir algo propio."
            </p>

            <button onClick={onOpenModal} className="w-full md:w-auto bg-brand-gold hover:bg-yellow-400 text-brand-bg font-black text-lg py-4 px-10 rounded-xl shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 mx-auto group" data-id="element-35">
              ASEGURAR MI CUPO GRATIS
              <ChevronRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-36" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}